// Transportkategorie aus dem Deal-/Projekttitel ableiten (gleiche Logik wie das 🎹-Icon in der Tourenplanung).
export const getTransportCategory = (title) => {
  const lower = (title || '').toLowerCase();
  if (lower.includes('flügel') || lower.includes('fluegel')) return 'grand_piano';
  if (lower.includes('piano') || lower.includes('klavier')) return 'piano';
  return null;
};

const CATEGORY_NAME_PATTERNS = {
  piano: /klavier/i,
  grand_piano: /flügel/i
};

/**
 * Filtert Transport-/Terminarten auf die passenden Klavier-/Flügel-Typen,
 * wenn ALLE Deals der Tour Klavier- oder Flügeltransporte sind. Sonst bleibt die Liste unverändert.
 */
export const filterTypesForDeals = (types, deals) => {
  const categories = (deals || []).map(d => getTransportCategory(d?.title));
  if (categories.length === 0 || categories.some(c => c === null)) {
    return { types, filtered: false };
  }
  const patterns = [...new Set(categories)].map(c => CATEGORY_NAME_PATTERNS[c]);
  const matching = types.filter(t => patterns.some(p => p.test(t.name)));
  return matching.length > 0 ? { types: matching, filtered: true } : { types, filtered: false };
};
